<div class="registration-container">
  <form [formGroup]="vendorForm" (ngSubmit)="submitVendorForm()" class="form-container">

    <!-- ===================== COMPANY INFORMATION ===================== -->
    <h2 class="section-title">Company Information</h2>
    <div class="form-section grid-2">
      <mat-form-field appearance="outline">
        <mat-label>Company Name</mat-label>
        <input matInput formControlName="companyName" required />
      </mat-form-field>

      <!-- <mat-form-field appearance="outline">
        <mat-label>Country</mat-label>
        <mat-select formControlName="countryId" required>
          <mat-option *ngFor="let c of countries$ | async" [value]="c.id">
            {{ c.name }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->

      <mat-form-field appearance="outline" class="leave-type">
        <mat-label>Country</mat-label>
        <input type="text" matInput [matAutocomplete]="auto" placeholder="Select or type country"
          [formControl]="countryControl" />
        <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption [displayWith]="displayCountryName"
          (optionSelected)="onCountrySelected($event.option.value)">
          <mat-option *ngFor="let g of filteredCountries$ | async" [value]="g">
            {{ g.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>State/Province</mat-label>
        <mat-select formControlName="stateId" required>
          <mat-option *ngFor="let s of states$ | async" [value]="s.id">
            {{ s.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>District/Neighborhood</mat-label>
        <input matInput formControlName="districtOrNeighborhood" />
      </mat-form-field>
    </div>
    <div class="form-section grid-2">

      <mat-form-field appearance="outline">
        <mat-label>Address 1</mat-label>
        <textarea matInput formControlName="address1" rows="3" required></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Address 2</mat-label>
        <textarea matInput formControlName="address2" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="form-section grid-2">
      <mat-form-field appearance="outline">
        <mat-label>City</mat-label>
        <input matInput formControlName="city" required />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>ZipCode</mat-label>
        <input matInput formControlName="zipCode" />
      </mat-form-field>
      <!-- <div class="form-section grid-2"> -->
      <mat-form-field appearance="outline">
        <mat-label>Building Number</mat-label>
        <input matInput formControlName="buildingNumber" required />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Commercial Reg. No</mat-label>
        <input matInput formControlName="commercialRegNo" required />
        <!-- <mat-error *ngIf="vendorForm.get('commercialRegNo')?.hasError('required')">
          Commercial Registration Number is required
        </mat-error> -->

        <mat-error *ngIf="vendorForm.get('commercialRegNo')?.hasError('pattern')">
          Must be exactly 10 digits
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>VAT Number</mat-label>
        <input matInput formControlName="vatNumber" required />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Group VAT Number</mat-label>
        <input matInput formControlName="groupVatNumber" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Other ID</mat-label>
        <input matInput formControlName="otherId" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Nature of your business</mat-label>
        <!-- <mat-select formControlName="businessID" required>
          <mat-option *ngFor="let t of tags$ | async" [value]="t.id">
            {{ t.name }}
          </mat-option>
        </mat-select> -->
        <mat-select formControlName="businessID" multiple>
          <mat-option *ngFor="let t of tags$ | async" [value]="t.id">
            {{ t.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Phone</mat-label>
        <input matInput formControlName="phone" required />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" required autocomplete="off" autocorrect="off" spellcheck="false" />
        <!-- <mat-error *ngIf="vendorForm.get('email')?.hasError('required')">
          Email is required
        </mat-error> -->

        <mat-error *ngIf="vendorForm.get('email')?.hasError('email')">
          Please enter a valid email address
        </mat-error>
      </mat-form-field>

      <!-- 
      <mat-form-field appearance="outline">
        <mat-label>Re Password</mat-label>
        <input matInput formControlName="password" required />
      </mat-form-field> -->

      <mat-form-field appearance="outline">
        <mat-label>Password</mat-label>
        <input matInput type="password" formControlName="password" required autocomplete="off" />
        <!-- <mat-error *ngIf="vendorForm.get('password')?.hasError('required')">
          Password is required
        </mat-error> -->

        <mat-error *ngIf="vendorForm.get('password')?.hasError('minlength')">
          Minimum 8 characters required
        </mat-error>

        <!-- <mat-error *ngIf="vendorForm.get('password')?.hasError('maxlength')">
          Maximum 20 characters allowed
        </mat-error>

        <mat-error *ngIf="vendorForm.get('password')?.hasError('pattern')">
          Must include uppercase, lowercase, number and special character
        </mat-error> -->
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Confirm Password</mat-label>
        <input matInput type="password" formControlName="confirmpassword">
        <!-- <mat-error *ngIf="vendorForm.get('confirmpassword')?.hasError('required')">
          Confirm Password is required
        </mat-error> -->
        <mat-error *ngIf="vendorForm.get('confirmpassword')?.hasError('mismatch')">
          Passwords do not match
        </mat-error>
      </mat-form-field>

    </div>

    <!-- ===================== BUSINESS INFORMATION ===================== -->
    <h2 class="section-title">Contact Information</h2>

    <div class="form-section grid-2">

      <mat-form-field appearance="outline">
        <mat-label>Title</mat-label>
        <mat-select formControlName="titleId">
          <mat-option *ngFor="let t of titles$ | async" [value]="t.id">
            {{ t.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Contact Person</mat-label>
        <input matInput formControlName="contactPerson" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Designation</mat-label>
        <input matInput formControlName="designation" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Phone</mat-label>
        <input matInput formControlName="contactphone" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Mobile Number</mat-label>
        <input matInput formControlName="mobile" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput formControlName="contactemail" />
        <mat-error *ngIf="vendorForm.get('contactemail')?.hasError('required')">
          Email is required
        </mat-error>

        <mat-error *ngIf="vendorForm.get('contactemail')?.hasError('email')">
          Please enter a valid email address
        </mat-error>
      </mat-form-field>

    </div>


    <div class="form-section grid-2">
      <!-- <mat-form-field appearance="outline"> -->
      <mat-checkbox formControlName="suppliedEarlier">
        Have you supplied the material to GS earlier?
      </mat-checkbox>
      <!-- </mat-form-field> -->

      <div *ngIf="vendorForm.get('suppliedEarlier')?.value">
        <mat-form-field appearance="outline">
          <mat-label>Month & Year</mat-label>
          <input matInput formControlName="suppliedMonthYear" />
        </mat-form-field>
      </div>
    </div>

    <!-- ===================== FILE UPLOADS ===================== -->
    <h2 class="section-title">Upload Documents</h2>
    <div class="form-section grid-3">
      <div class="file-upload">
        <label>Company Registration Certificate*</label>
        <div class="upload-wrapper">
          <button mat-raised-button color="primary" type="button" (click)="crFileInput.click()">
            <mat-icon>upload_file</mat-icon> Choose File
          </button>
          <span class="file-name">{{ CRFileName || 'No file chosen' }}</span>
          <input #crFileInput type="file" (change)="onFileChange($event, 'CR')" hidden />
        </div>
      </div>

      <div class="file-upload">
        <label>Company VAT Certificate*</label>
        <div class="upload-wrapper">
          <button mat-raised-button color="primary" type="button" (click)="vatFileInput.click()">
            <mat-icon>upload_file</mat-icon> Choose File
          </button>
          <span class="file-name">{{ VATFileName || 'No file chosen' }}</span>
          <input #vatFileInput type="file" (change)="onFileChange($event, 'VAT')" hidden />
        </div>
      </div>

      <div class="file-upload">
        <label>MOMRA License*</label>
        <div class="upload-wrapper">
          <button mat-raised-button color="primary" type="button" (click)="momraFileInput.click()">
            <mat-icon>upload_file</mat-icon> Choose File
          </button>
          <span class="file-name">{{ MOMRAFileName || 'No file chosen' }}</span>
          <input #momraFileInput type="file" (change)="onFileChange($event, 'MOMRA')" hidden />
        </div>
      </div>

      <div class="file-upload">
        <label>MSLD License*</label>
        <div class="upload-wrapper">
          <button mat-raised-button color="primary" type="button" (click)="msldFileInput.click()">
            <mat-icon>upload_file</mat-icon> Choose File
          </button>
          <span class="file-name">{{ MSLDFileName || 'No file chosen' }}</span>
          <input #msldFileInput type="file" (change)="onFileChange($event, 'MSLD')" hidden />
        </div>
      </div>

      <div class="file-upload">
        <label>SAGIA License*</label>
        <div class="upload-wrapper">
          <button mat-raised-button color="primary" type="button" (click)="sagiaFileInput.click()">
            <mat-icon>upload_file</mat-icon> Choose File
          </button>
          <span class="file-name">{{ SAGIAFileName || 'No file chosen' }}</span>
          <input #sagiaFileInput type="file" (change)="onFileChange($event, 'SAGIA')" hidden />
        </div>
      </div>

      <div class="file-upload">
        <label>IBAN License*</label>
        <div class="upload-wrapper">
          <button mat-raised-button color="primary" type="button" (click)="ibanFileInput.click()">
            <mat-icon>upload_file</mat-icon> Choose File
          </button>
          <span class="file-name">{{ IBANFileName || 'No file chosen' }}</span>
          <input #ibanFileInput type="file" (change)="onFileChange($event, 'IBAN')" hidden />
        </div>
      </div>
    </div>

    <!-- <div class="form-section grid-2">
      <div class="file-upload">
        <label>Company Registration Certificate*</label>
        <div class="upload-wrapper">
          <button mat-raised-button color="primary" type="button" (click)="crFileInput.click()">
            <mat-icon>upload_file</mat-icon> Choose File
          </button>
          <span class="file-name">{{ CRFileName || 'No file chosen' }}</span>
          <input #crFileInput type="file" (change)="onFileChange($event, 'CR')" hidden />
        </div>
      </div>

      <div class="file-upload">
        <label>Company VAT Certificate*</label>
        <div class="upload-wrapper">
          <button mat-raised-button color="primary" type="button" (click)="vatFileInput.click()">
            <mat-icon>upload_file</mat-icon> Choose File
          </button>
          <span class="file-name">{{ VATFileName || 'No file chosen' }}</span>
          <input #vatFileInput type="file" (change)="onFileChange($event, 'VAT')" hidden />
        </div>
      </div>

      <div class="file-upload">
        <label>MOMRA License*</label>
        <div class="upload-wrapper">
          <button mat-raised-button color="primary" type="button" (click)="momraFileInput.click()">
            <mat-icon>upload_file</mat-icon> Choose File
          </button>
          <span class="file-name">{{ MOMRAFileName || 'No file chosen' }}</span>
          <input #momraFileInput type="file" (change)="onFileChange($event, 'MOMRA')" hidden />
        </div>
      </div>

      <div class="file-upload">
        <label>MSLD License*</label>
        <div class="upload-wrapper">
          <button mat-raised-button color="primary" type="button" (click)="msldFileInput.click()">
            <mat-icon>upload_file</mat-icon> Choose File
          </button>
          <span class="file-name">{{ MSLDFileName || 'No file chosen' }}</span>
          <input #msldFileInput type="file" (change)="onFileChange($event, 'MSLD')" hidden />
        </div>
      </div>

      <div class="file-upload">
        <label>SAGIA License*</label>
        <div class="upload-wrapper">
          <button mat-raised-button color="primary" type="button" (click)="sagiaFileInput.click()">
            <mat-icon>upload_file</mat-icon> Choose File
          </button>
          <span class="file-name">{{ SAGIAFileName || 'No file chosen' }}</span>
          <input #sagiaFileInput type="file" (change)="onFileChange($event, 'SAGIA')" hidden />
        </div>
      </div>
      <div class="file-upload">
        <label>IBAN License*</label>
        <div class="upload-wrapper">
          <button mat-raised-button color="primary" type="button" (click)="ibanFileInput.click()">
            <mat-icon>upload_file</mat-icon> Choose File
          </button>
          <span class="file-name">{{ IBANFileName || 'No file chosen' }}</span>
          <input #ibanFileInput type="file" (change)="onFileChange($event, 'IBAN')" hidden />
        </div>
      </div>
    </div> -->
    <!-- Submit -->
    <div class="form-actions">
      <!-- <button mat-raised-button color="primary" type="submit" class="submit-vendor-btn">
        Submit Vendor
      </button> -->

      <button mat-raised-button color="primary" type="submit" class="submit-vendor-btn">
        <span *ngIf="!isLoading"> Next</span>
        <span *ngIf="isLoading" class="loader"></span>
      </button>
    </div>
  </form>
</div>